/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles } from '@material-ui/core';
import { Settings, Subject } from '@material-ui/icons';
import clsx from 'clsx';
import TextEditor from 'components/TextEditor';
import ToggleCard from 'components/ToggleCard';
import i18n from 'i18n';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';
import React from 'react';
import GenericForm from 'skyone-lib/lib/GenericForm';
import { inAdminView, inOperatorView, inSuperAdminView } from 'utils/role';
import styles from '../styles';

const useStyles = makeStyles(styles);

export interface MaintenanceImmediate {
  enabled: boolean;
  message: string;
  terminate_sessions: boolean;
  terminate_instances: boolean;
}

export const immediateInitialValues = {
  enabled: false,
  message: '',
  terminate_sessions: false,
  terminate_instances: false,
};

export interface Props {
  defaultValue: MaintenanceImmediate;
  companySelected: CompanyData | null;
  role?: RolesEnum;
  onChange: (values: MaintenanceImmediate) => void;
}

const Form = ({ defaultValue, role, companySelected, onChange }: Props) => {
  const classes = useStyles();
  const [values, setValues] = React.useState<MaintenanceImmediate>(
    immediateInitialValues
  );

  const handleChange = (values: MaintenanceImmediate, toggle: boolean) => {
    const newValues = { ...values, enabled: toggle };

    setValues(newValues);
    onChange(newValues);
  };

  React.useEffect(() => {
    if (defaultValue) {
      setValues(defaultValue);
    }
  }, [defaultValue]);

  return (
    <ToggleCard
      active={values.enabled}
      id="toggle-manual-maintenance"
      title={i18n.t('MAINTENANCE_MANUAL_KEY')}
      icon={
        <Settings
          className={clsx({
            [classes.iconGreen]: inAdminView(role, companySelected),
            [classes.iconGray]: inSuperAdminView(role, companySelected),
            [classes.iconBlue]: inOperatorView(role, companySelected),
            [classes.iconYellow]: companySelected,
          })}
        />
      }
      getActive={(value: boolean) => handleChange(values, !value)}
    >
      <Grid container className={classes.FormContainer}>
        <GenericForm
          overrideClasses={{ checkboxLabel: { fontSize: 12, fontWeight: 500 } }}
          errors={[]}
          values={values}
          setFieldValue={(key, value) =>
            handleChange({ ...values, [key]: value }, values.enabled)
          }
          screenFields={[
            {
              gridXs: 12,
              label: i18n.t('TERMINATE_SESSIONS_KEY'),
              stateKey: 'terminate_sessions',
              isCheckbox: true,
            },
            {
              gridXs: 12,
              label: i18n.t('TERMINATE_INSTANCES_KEY'),
              stateKey: 'terminate_instances',
              isCheckbox: true,
            },
          ]}
        />

        <Grid item className={classes.textFieldContainer}>
          <Subject className={classes.iconMaintenance} />

          <TextEditor
            initialValue={values.message || ''}
            title={i18n.t('ADD_MESSAGE_MAINTENANCE_KEY')}
            getValue={(value: string) =>
              handleChange({ ...values, message: value }, values.enabled)
            }
            maxLength={800}
          />
        </Grid>
      </Grid>
    </ToggleCard>
  );
};

export default Form;
